<style scoped lang="scss">
@import '../assets/style/_mixin.scss';

.login_body {
  height: 100%;
  width: 100%;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  background-color: #f5f5f5;
  text-align: center;
}
._logo {
  width: 40%;
  height: 40%;
}
.form-forgot-password {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}
</style>

<template>
  <div class="login_body">
    <form class="form-forgot-password">
      <img class="_logo" :src="logo">
      <h1 class="h3 mb-3">Forgot Password?</h1>
      <InputFloatLabel
        type="email"
        id="inputEmail"
        name="Account Email"
        placeholder="Email address"
        :autofocus="true"
        :value.sync="userAccount"
        rule="required|email"
      />
      <div class="row">
        <div class="col-12">
          <b-button :block="true" variant="primary" @click="clickResetPassword()" :disabled="errors.has('Account Email') || userAccount === '' || btnLock">Send password reset email</b-button>
        </div>
      </div>
      <p class="mt-5 mb-3 text-muted">© Intrising Networks, Inc.</p>
    </form>
  </div>
</template>

<script>
// import { compact, size } from 'lodash'
import logo from '@/assets/intrising-logo/logo.svg'
import InputFloatLabel from '@/components/InputFloatLabel.vue'
import { resetPassword } from '@/firebaseRef'

export default {
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  components: {
    InputFloatLabel
  },
  data () {
    return {
      logo,
      userAccount: '',
      btnLock: false
    }
  },
  firebase () {
    return {

    }
  },
  computed: {

  },
  methods: {
    clickResetPassword () {
      const { userAccount } = this
      if (!this.errors.any()) {
        this.btnLock = true
        resetPassword(userAccount)
          .then((res) => {
            console.log(res)
            // this.alert('success', '', 'Your password has been reset successfully. Please check your email for more detail.')
          })
          .catch(err => {
            this.btnLock = false
            console.log(err)
            // this.alert('danger', 'Error', err)
          })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ForgotPassword.vue